import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  pointer-events: none;\n\n  img {\n    align-items: center;\n    display: flex;\n    height: ", ";\n    max-width: 100%;\n    width: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { getCSSUnitValue } from '@scp/ui-shared/theme/utils';
var ImageWrapper = styled.div(_templateObject(), function (props) {
  return props.$height ? getCSSUnitValue(props.$height) : 'auto';
}, function (props) {
  return props.$width ? getCSSUnitValue(props.$width) : 'auto';
});
export var Image = function Image(_ref) {
  var url = _ref.url,
      title = _ref.title,
      width = _ref.width,
      height = _ref.height;
  return React.createElement(ImageWrapper, {
    "$height": height,
    "$width": width
  }, React.createElement("img", {
    src: url,
    alt: title
  }));
};